/**
 * Checks whether a ContactPoint is filled or not.
 * @param cp ContactPoint
 * @returns `true` if the ContactPoint is filled; `false`if is empty.
 */
export function isContactPointComplete(cp: { categoryContactPointId?: number; contactValue?: string }): boolean {
	const hasCategory = (cp.categoryContactPointId ?? -1) > 0;
	const hasValue = (cp.contactValue ?? '').trim().length > 0;
	return hasCategory && hasValue;
}
